import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { RefreshCw } from "lucide-react";

const relTime = (iso) => {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "baru saja";
  if (mins < 60) return `${mins} menit lalu`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} jam lalu`;
  return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
};

export const LastUpdated = ({ className = "" }) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get("/status/last-update").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  if (!status?.last_run) return null;
  return (
    <div data-testid="last-updated" className={`flex items-center gap-2 text-xs font-mono text-slate-500 ${className}`}>
      <RefreshCw className="w-3 h-3 text-cyan1" />
      <span>Terakhir diperbarui: {relTime(status.last_run)}</span>
      {status.auto_update_enabled && (
        <span className="chip chip-green text-[10px]" data-testid="auto-update-badge">AUTO · {status.interval_hours}J</span>
      )}
    </div>
  );
};
